import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../baseQuery';
import { createInvoiceSettings, listInvoiceSettings } from '../../graphql';
import { createPOSInvoiceSettings } from '../../graphql/mutations';

export const InvoiceSettingsApi = createApi({
    reducerPath: 'invoiceSettingsApi',
    baseQuery: baseQuery,
    endpoints: (builder) => ({
        listInvoiceSettings: builder.query({
            query: (variables) => ({ body: listInvoiceSettings, variables }),
            keepUnusedDataFor: Infinity,
            refetchOnMountOrArgChange: true,
            providesTags: (result, error, { type }) => [
                { type: "listInvoiceSettings", id: type },
            ],
        }),
        createInvoiceSettings: builder.mutation({
            query: (variables) => ({ body: createInvoiceSettings, variables }),
            invalidatesTags: (result, error, { type }) => [
                { type: "listInvoiceSettings", id: type },
            ],
        }),
        createPOSInvoiceSettings: builder.mutation({
            query: (variables) => ({ body: createPOSInvoiceSettings, variables }),
            invalidatesTags: (result, error, { type }) => [
                { type: "listInvoiceSettings", id: type },
            ],
        }),

    }),
});

export const { useListInvoiceSettingsQuery, useCreateInvoiceSettingsMutation, useCreatePOSInvoiceSettingsMutation } = InvoiceSettingsApi;
